import { baseURL } from "../utils/constants";
import apiClient from "./fetch";

export const getWaLeads = async (
  hospital_id: string,
  date: string,
  page: number = 1,
  limit: number = 10,
  status: string = "open"
) => {
  try {
    const response = await apiClient.get(
      `${baseURL}/wa/leads?hospital_id=${hospital_id}&date=${date}&page=${page}&limit=${limit}&status=${status}`
    );
    return response;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

export const updateWaLead = async (
  session_code: string,
  body: {
    drop_off_reason?: string;
    is_converted?: boolean;
    converted_by?: string;
  }
) => {
  try {
    const response = await apiClient.patch(
      `${baseURL}/wa/leads/${session_code}`,
      body
    );
    return response;
  } catch (error: any) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};
